import { loadScript } from '@core/utils/helpers';
import apiConfig from '@customer/config/api.config';
interface ILoginAPI extends Window {
  LoginAPI: any;
}

declare const window: ILoginAPI;

export async function loginApiClient(instance?: string) {
  const isServer = typeof window === 'undefined';

  if (isServer) {
    return;
  }

  let LoginAPI = window.LoginAPI || null;

  if (!window.LoginAPI) {
    const script = apiConfig.login_api_client_url[String(instance) as keyof typeof apiConfig.login_api_client_url] || apiConfig.login_api_client_url.default;
    await loadScript({
      script,
      attr: {
        id: 'login-client',
        async: 'async',
      },
    });
    LoginAPI = window.LoginAPI;
  }

  return LoginAPI;
}
